import { AppState } from 'common/appState';

export const getAuthenticatedStatus = (state: AppState) => state.auth.isAuthenticated;
export const getTokenStatus = (state: AppState) => state.auth.isTokenChecked;
export const getUserVerificationStatus = (state: AppState) => state.auth.isUserVerified;
export const isAuthProcessing = (state: AppState) => state.auth.isProcessing;
export const checkIfUserExists = (state: AppState) => state.auth.userExists;
